module.exports = __webpack_public_path__ + "7f82b0244b17bdc6d71e668191e82b04.svg";